module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"gl":{"info-travel":"Info Viaxe:","num-linhas":"Liñas","xornada-inf":"Xornada de Educación Infantil","xornada-prim":"Xornada de Educación Primaria","telefono":"Teléfono","fax":"Fax","web":"Web","email":"Enderezo email","ramas-bac":"Ramas Bacharelato","enderezo":"Enderezo","servizos":"Servizos","linha-recta":"(en liña recta)"},"es":{"info-travel":"Info Viaje:","xornada-inf":"Jornada de Educación Infantil","xornada-prim":"Jornada de Educación Primaria","telefono":"Teléfono","fax":"Fax","web":"Web","email":"Dirección email","ramas-bac":"Ramas Bachillerato","enderezo":"Direccioń","servizos":"Servicios","linha-recta":"(en linea recta)"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/Center.vue
// module id = 57
// module chunks = 0